import { BreakpointAction, QuizDataInput, TrueOrFalseOption } from '@naturalcycles/shared'
import { addPageInSectionAtIndex, filterPagesFromSection } from '@src/app/core/util/quiz.util.js'
import { Page } from '@src/app/shared/typings/enum/pages.js'
import { DefaultSections } from '@src/app/shared/typings/enum/quiz.js'
import { allQuizSections } from '../quiz.js'

export const periodTrackerUsage: BreakpointAction<TrueOrFalseOption, Page, QuizDataInput> = {
  [TrueOrFalseOption.true]: flow => {
    const periodTrackerUsageIndex =
      flow[allQuizSections.cycle]?.findIndex(page => page === Page.periodTrackerUsage) ?? -1

    if (periodTrackerUsageIndex === -1) {
      return flow
    }

    flow = addPageInSectionAtIndex(
      flow,
      Page.whichPeriodTracker,
      DefaultSections.cycle,
      periodTrackerUsageIndex + 1,
    )

    flow = addPageInSectionAtIndex(
      flow,
      Page.periodTrackerComparison,
      DefaultSections.cycle,
      periodTrackerUsageIndex + 2,
    )

    return flow
  },
  [TrueOrFalseOption.false]: flow => {
    const periodTrackerUsageIndex =
      flow[allQuizSections.cycle]?.findIndex(page => page === Page.periodTrackerUsage) ?? -1

    if (periodTrackerUsageIndex === -1) {
      return flow
    }
    flow = filterPagesFromSection(flow, [Page.whichPeriodTracker], DefaultSections.cycle)
    flow = addPageInSectionAtIndex(
      flow,
      Page.periodTrackerComparison,
      DefaultSections.cycle,
      periodTrackerUsageIndex + 1,
    )

    return flow
  },
}
